import { useState } from 'react';
import { Button, Card, SelectField, TextField } from '../components/ui.jsx';
import { ListIcon, MapPin } from '../components/icons.jsx';

/**
 * Step two: pick the address.
 *
 * The design specifies a native select, which also happens to be the right
 * control here — the list can run to a hundred entries and a native picker is
 * what a phone renders best. The postcode above it is shown read-only so the
 * customer can see what was matched without being able to desync it from the
 * address list; changing it means going back a step.
 */
export default function AddressStep({ postcode, addresses, onSelect, onBack }) {
  const [selectedId, setSelectedId] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    const address = addresses.find((a) => a.id === selectedId);
    if (!address) {
      setError('Please select your address');
      return;
    }

    onSelect(address);
  };

  return (
    <Card>
      <form onSubmit={handleSubmit} noValidate>
        <TextField
          label="Your Postcode"
          icon={ListIcon}
          trailingIcon={MapPin}
          name="postcode"
          value={postcode}
          readOnly
          // The value is fixed by the previous step, so this is a display of
          // state rather than an input — but it stays focusable so a keyboard
          // user tabbing through can still read it.
          onChange={() => {}}
        />

        <SelectField
          label="Select Your Address"
          icon={ListIcon}
          placeholder="Please Select....."
          value={selectedId}
          error={error}
          onChange={(e) => {
            setSelectedId(e.target.value);
            if (error) setError(null);
          }}
          required
        >
          {addresses.map((address) => (
            <option key={address.id} value={address.id}>
              {address.label}
            </option>
          ))}
        </SelectField>

        <Button type="submit">Next Step</Button>
      </form>

      {/* Kept for parity with the postcode step's back affordance on mobile,
          where the header back link scrolls out of view. */}
      <button type="button" className="card__back" onClick={onBack}>
        Change postcode
      </button>
    </Card>
  );
}
